// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CartList_table__2AwiQ {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.CartList_table__2AwiQ th,
td {
  padding: 10px;
  text-align: left;
  /* border-bottom: 1px solid #ddd; */
}

.CartList_table__2AwiQ th {
  background-color: #f8f8f8;
  font-weight: bold;
  font-size: 16px;
}

.CartList_priceCol__81pvv {
  width: 12%;
  text-align: center;
}

.CartList_row__upCZT {
  background-color: #fff;
  transition: background-color 0.3s;
}

.CartList_row__upCZT:hover {
  background-color: #f9f9f9;
}

.CartList_productDetails__v5UIg {
  display: flex;
  align-items: center;
  gap: 10px;
}

.CartList_productImage__QrKSp {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 5px;
}

.CartList_quantity__LhuDK {
  /* display: flex; */
  align-items: center;
  gap: 10px;
}

.CartList_price__EjIQ7 {
  font-weight: bold;
  color: #333;
  font-size: 17px;
}

.CartList_removeBtn__nsgj8 i {
  color: #ff6b6b;
}

.CartList_description__N9gZA p {
  color: #666;
  font-size: 9px;
}

.CartList_description__N9gZA li {
  color: #666;
  font-size: 9px;
}

.CartList_descriptionText__1Hc2c p {
  color: #666;
  font-size: 16px;
}

.CartList_name__eBRm3 {
  color: rgb(240, 12, 12);
  font-size: 16px;
  text-decoration: none;
}

.CartList_name__eBRm3:hover {
  color: rgb(150, 9, 9);
}

.CartList_quantity__LhuDK i {
  color: rgb(240, 12, 12);
}

.CartList_quantityContainer__3ItHj {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.CartList_button__7sVMw {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.CartList_button__7sVMw:hover {
  background-color: #e0e0e0;
}

.CartList_quantityValue__ioP2j {
  width: 50px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: 1px solid #ddd;
  margin: 0 5px;
  border-radius: 4px;
  background-color: white;
  font-size: 16px;
}

.CartList_centered__kJwou {
  text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
  .CartList_table__2AwiQ {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    gap: 0; /* Dacă folosești gap în layout */
  }

  .CartList_table__2AwiQ th,
  .CartList_table__2AwiQ td {
    padding: 0;
    margin: 0;
    border: none; /* Elimină și bordurile, dacă este necesar */
    padding: 5px;
  }

  .CartList_productDetails__v5UIg {
    display: flex;
    align-items: center;
    gap: 0px;
  }

  .CartList_quantity__LhuDK {
    /* display: flex; */
    align-items: center;
    gap: 0px;
  }

  .CartList_quantityValue__ioP2j {
    width: 25px;
  }

  .CartList_button__7sVMw {
    width: 15px;
    height: 15px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .CartList_quantityContainer__3ItHj {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .CartList_price__EjIQ7 {
    font-weight: bold;
    color: #333;
    font-size: 15px;
    text-align: center;
  }

  .CartList_priceCol__81pvv {
    width: 21%;
    text-align: center;
  }

  .CartList_productColumn__2kpX3 {
    width: 58%;
  }
  .CartList_product__W12ZN {
    margin-left: 5px;
  }
  .CartList_name__eBRm3 {
    color: rgb(240, 12, 12);
    font-size: 15px;
    text-decoration: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/OrderReview/CartList/CartList.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,MAAM,EAAE,iCAAiC;EAC3C;;EAEA;;IAEE,UAAU;IACV,SAAS;IACT,YAAY,EAAE,4CAA4C;IAC1D,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,qBAAqB;EACvB;AACF","sourcesContent":[".table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table th,\ntd {\n  padding: 10px;\n  text-align: left;\n  /* border-bottom: 1px solid #ddd; */\n}\n\n.table th {\n  background-color: #f8f8f8;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.priceCol {\n  width: 12%;\n  text-align: center;\n}\n\n.row {\n  background-color: #fff;\n  transition: background-color 0.3s;\n}\n\n.row:hover {\n  background-color: #f9f9f9;\n}\n\n.productDetails {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.productImage {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.quantity {\n  /* display: flex; */\n  align-items: center;\n  gap: 10px;\n}\n\n.price {\n  font-weight: bold;\n  color: #333;\n  font-size: 17px;\n}\n\n.removeBtn i {\n  color: #ff6b6b;\n}\n\n.description p {\n  color: #666;\n  font-size: 9px;\n}\n\n.description li {\n  color: #666;\n  font-size: 9px;\n}\n\n.descriptionText p {\n  color: #666;\n  font-size: 16px;\n}\n\n.name {\n  color: rgb(240, 12, 12);\n  font-size: 16px;\n  text-decoration: none;\n}\n\n.name:hover {\n  color: rgb(150, 9, 9);\n}\n\n.quantity i {\n  color: rgb(240, 12, 12);\n}\n\n.quantityContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.button {\n  width: 25px;\n  height: 25px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.button:hover {\n  background-color: #e0e0e0;\n}\n\n.quantityValue {\n  width: 50px;\n  height: 30px;\n  text-align: center;\n  line-height: 30px;\n  border: 1px solid #ddd;\n  margin: 0 5px;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 16px;\n}\n\n.centered {\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n    gap: 0; /* Dacă folosești gap în layout */\n  }\n\n  .table th,\n  .table td {\n    padding: 0;\n    margin: 0;\n    border: none; /* Elimină și bordurile, dacă este necesar */\n    padding: 5px;\n  }\n\n  .productDetails {\n    display: flex;\n    align-items: center;\n    gap: 0px;\n  }\n\n  .quantity {\n    /* display: flex; */\n    align-items: center;\n    gap: 0px;\n  }\n\n  .quantityValue {\n    width: 25px;\n  }\n\n  .button {\n    width: 15px;\n    height: 15px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n\n  .quantityContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  .price {\n    font-weight: bold;\n    color: #333;\n    font-size: 15px;\n    text-align: center;\n  }\n\n  .priceCol {\n    width: 21%;\n    text-align: center;\n  }\n\n  .productColumn {\n    width: 58%;\n  }\n  .product {\n    margin-left: 5px;\n  }\n  .name {\n    color: rgb(240, 12, 12);\n    font-size: 15px;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `CartList_table__2AwiQ`,
	"priceCol": `CartList_priceCol__81pvv`,
	"row": `CartList_row__upCZT`,
	"productDetails": `CartList_productDetails__v5UIg`,
	"productImage": `CartList_productImage__QrKSp`,
	"quantity": `CartList_quantity__LhuDK`,
	"price": `CartList_price__EjIQ7`,
	"removeBtn": `CartList_removeBtn__nsgj8`,
	"description": `CartList_description__N9gZA`,
	"descriptionText": `CartList_descriptionText__1Hc2c`,
	"name": `CartList_name__eBRm3`,
	"quantityContainer": `CartList_quantityContainer__3ItHj`,
	"button": `CartList_button__7sVMw`,
	"quantityValue": `CartList_quantityValue__ioP2j`,
	"centered": `CartList_centered__kJwou`,
	"productColumn": `CartList_productColumn__2kpX3`,
	"product": `CartList_product__W12ZN`
};
export default ___CSS_LOADER_EXPORT___;
